import { render } from "./fileImagePreview.vue?vue&type=template&id=704c1458&scoped=true"
import script from "./fileImagePreview.vue?vue&type=script&lang=js"
export * from "./fileImagePreview.vue?vue&type=script&lang=js"

import "./fileImagePreview.vue?vue&type=style&index=0&id=704c1458&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704c1458"]])

export default __exports__